// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AddAccountType Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999999999999999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  width: 50%;
  
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-close-btn {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 0.5rem;
  font-size: 1.25rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.modal-close-btn:hover {
  background: #dc3545;
  color: white;
  border-color: #dc3545;
}

.form-section {
  padding: 1rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.25rem 0;
}

.form-label {
  font-size: 1.125rem;
  font-weight: 500;
  color: #333;
}

.required-asterisk {
  color: #dc3545;
}

.form-control {
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-control:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem;
  padding: 0 1rem;
}

.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.25rem 0;
}

.checkbox-label {
  font-size: 1.125rem;
  font-weight: 500;
  color: #333;
}

.form-check-input {
  width: 1.25rem;
  height: 1.25rem;
  margin-top: 0.25rem;
  cursor: pointer;
}

.error-message {
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}

.submit-button {
  background-color: #0d6efd;
  color: white;
  font-weight: bold;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  font-size: 1.125rem;
  border: none;
  cursor: pointer;
  transition: background-color 0.15s ease-in-out;
  margin: 1rem auto;
  display: block;
}

.submit-button:hover:not(:disabled) {
  background-color: #0b5ed7;
}

.submit-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .modal-content {
    width: 90%;
    padding: 1rem;
  }
  
  .checkbox-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .checkbox-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/referenes/component/AddAccountType.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,UAAU;;EAEV,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,wEAAwE;AAC1E;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,8CAA8C;EAC9C,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* AddAccountType Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 999999999999999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal-content {\n  background: white;\n  padding: 2rem;\n  border-radius: 8px;\n  width: 50%;\n  \n  max-height: 90vh;\n  overflow-y: auto;\n  position: relative;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.modal-close-btn {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  padding: 0.5rem;\n  font-size: 1.25rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.modal-close-btn:hover {\n  background: #dc3545;\n  color: white;\n  border-color: #dc3545;\n}\n\n.form-section {\n  padding: 1rem;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  padding: 0.25rem 0;\n}\n\n.form-label {\n  font-size: 1.125rem;\n  font-weight: 500;\n  color: #333;\n}\n\n.required-asterisk {\n  color: #dc3545;\n}\n\n.form-control {\n  border: 1px solid #ced4da;\n  border-radius: 0.375rem;\n  padding: 0.5rem 0.75rem;\n  font-size: 1rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.form-control:focus {\n  border-color: #86b7fe;\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n\n.checkbox-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.5rem;\n  padding: 0 1rem;\n}\n\n.checkbox-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  padding: 0.25rem 0;\n}\n\n.checkbox-label {\n  font-size: 1.125rem;\n  font-weight: 500;\n  color: #333;\n}\n\n.form-check-input {\n  width: 1.25rem;\n  height: 1.25rem;\n  margin-top: 0.25rem;\n  cursor: pointer;\n}\n\n.error-message {\n  color: #dc3545;\n  font-size: 0.875rem;\n  margin-top: 0.25rem;\n}\n\n.submit-button {\n  background-color: #0d6efd;\n  color: white;\n  font-weight: bold;\n  padding: 0.5rem 1rem;\n  border-radius: 0.5rem;\n  font-size: 1.125rem;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.15s ease-in-out;\n  margin: 1rem auto;\n  display: block;\n}\n\n.submit-button:hover:not(:disabled) {\n  background-color: #0b5ed7;\n}\n\n.submit-button:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .modal-content {\n    width: 90%;\n    padding: 1rem;\n  }\n  \n  .checkbox-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 480px) {\n  .checkbox-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
